import {
  IDebugCampaignPacingModel,
  IHeaderbidderDebugPacingModel,
} from '~/src/dash/api/pacing/models';
import { generateTokenParams, restGet } from '~/src/dash/api/rest';
import { getPbsLogUS } from '~/src/dash/resellers/utils/importResellerConfig';

export async function getDebugCampaignPacingData(
  publisherID: string,
  campaignID: string,
): Promise<[IDebugCampaignPacingModel | undefined, string | undefined]> {
  const reqUrl =
    getPbsLogUS() +
    '/campaign_pacing_low?campaign_id=' +
    campaignID +
    '&' +
    generateTokenParams(publisherID);

  try {
    return [(await restGet<IDebugCampaignPacingModel>(reqUrl)).parsedBody, undefined];
  } catch (e) {
    return [undefined, e];
  }
}

export async function GetDebugCampaignsPacingData(
  publisherID: string,
  campaignIDs: string,
): Promise<[IDebugCampaignPacingModel[] | undefined, string | undefined]> {
  const reqUrl =
    getPbsLogUS() +
    '/campaigns_pacing_low?campaign_ids=' +
    campaignIDs +
    '&' +
    generateTokenParams(publisherID);

  try {
    return [(await restGet<IDebugCampaignPacingModel[]>(reqUrl)).parsedBody, undefined];
  } catch (e) {
    return [undefined, e];
  }
}

export async function GetDebugHeaderbidderPacingData(
  publisherID: string,
  headerbidderID: string,
): Promise<[IHeaderbidderDebugPacingModel | undefined, string | undefined]> {
  const reqUrl =
    getPbsLogUS() +
    '/debug/headerbidder_pacing?headerbidder_id=' +
    headerbidderID +
    '&' +
    generateTokenParams(publisherID);

  try {
    return [(await restGet<IHeaderbidderDebugPacingModel>(reqUrl)).parsedBody, undefined];
  } catch (e) {
    return [undefined, e];
  }
}
